import { RedirectStatus } from '../schemas/RedirectStatus';

export function isValidRedirectStatus(status: string): boolean {
  return (Object.values(RedirectStatus) as string[]).includes(status);
}
